module.exports = __webpack_public_path__ + "img/logo.7dc0e11.svg";